import { View, Text, StyleSheet, Link } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  footerContainer: {
    backgroundColor: '#F8FAFC',
    paddingVertical: 8,
    paddingHorizontal: 20,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderTopWidth: 1,
    borderTopColor: '#E2E8F0',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footerText: {
    fontSize: 8,
    fontFamily: 'Helvetica',
    color: '#000000',
  },
  footerLink: {
    fontSize: 8,
    fontFamily: 'Helvetica',
    color: '#000000',
    textDecoration: 'none',
  },
  pageNumberText: {
    fontSize: 8,
    fontFamily: 'Helvetica',
    color: '#000000',
  },
});

const PdfFooter = () => {
  return (
    <View style={styles.footerContainer} fixed>
      <Text style={styles.footerText}>
        © {new Date().getFullYear()} Smart Sea Freight • Confidential Maritime Document
      </Text>
      <Text
        style={styles.pageNumberText}
        render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
      />
      <Link src="https://www.smartseafreight.com" style={styles.footerLink}>
        www.smartseafreight.com
      </Link>
    </View>
  );
};

export default PdfFooter;